import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Constant from '../../Constant'
import CustomFooter from '../../common/TableBottom'
import Moment from 'react-moment'
import Button from '../../common/CustomComponents/Button'
import Loader from '../../common/Loader'

class NotificationList extends React.Component {
  state = {
    notifications: [],
    isloading: false,
    open: false,
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
    notificationType: '',
    userId: '',
  }
  debounceTimeout = null

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    this.setState({ isloading: true, open: true })

    const params = {
      pageNumber: this.state.pageNumber,
      limit: this.state.limit,
    }

    if (this.state.keyword) {
      params.keyword = this.state.keyword
    }

    if (this.state.notificationType) {
      params.notification_type = this.state.notificationType
    }

    if (this.state.userId) {
      params.user_id = this.state.userId
    }

    await axios
      .get(Constant.getAPI() + `/notification/get-all-notifications`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: params,
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            isloading: false,
            open: false,
            notifications: res.data.data || [],
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state.pageNumber + 1 >= res.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false, open: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.message || 'Error loading notifications',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  markAsRead = (notificationId) => {
    axios
      .put(
        Constant.getAPI() + `/notification/mark-read`,
        {
          notification_id: notificationId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          toast: true,
          icon: 'success',
          position: 'top-end',
          title: 'Marked as read!',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 2000,
        })
        this.loadData()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.message || 'Error marking notification as read',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  markAllAsRead = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will mark all notifications as read',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, mark all as read!',
    }).then((result) => {
      if (result.value) {
        axios
          .put(
            Constant.getAPI() + `/notification/mark-all-read`,
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
              },
            }
          )
          .then((res) => {
            Swal.fire({
              title: 'Success!',
              text: `${res.data.data.updated_count} notifications marked as read`,
              icon: 'success',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Ok',
            })
            this.loadData()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.message || 'Error marking all notifications as read',
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  deleteNotification = (notificationId) => {
    this.setState({ isloading: true, open: true })
    axios
      .delete(Constant.getAPI() + `/notification/delete`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        data: {
          notification_id: notificationId,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Deleted!',
          text: 'Notification has been deleted.',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
        this.loadData()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.message || 'Error deleting notification',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false, open: false })
      })
  }

  handleNotificationClick = (notification) => {
    // Mark as read if unread
    if (!notification.is_read) {
      this.markAsRead(notification.id)
    }

    // Redirect based on notification type
    if (notification.reference_type === 'CRUISE' && notification.reference_id) {
      window.location.href = `/#/booking-ordering/${notification.reference_id}`
    } else if (notification.reference_type === 'CHALET' && notification.reference_id) {
      window.location.href = `/#/chalet-booking-details/${notification.reference_id}`
    } else if (notification.reference_type === 'EVENT' && notification.reference_id) {
      window.location.href = `/#/new-evt/${notification.reference_id}`
    } else if (notification.reference_type === 'STORE' && notification.reference_id) {
      window.location.href = `/#/store-bookings-details/${notification.reference_id}`
    } else if (notification.reference_type === 'TRIP' && notification.reference_id) {
      window.location.href = `/#/cruise-trip-booking-details/${notification.reference_id}`
    } else {
      window.location.href = '/#/booking-payments'
    }
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.loadData()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.loadData()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }
    const columns = [
      {
        name: 'notification_type',
        label: 'Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (type) => {
            const typeConfig = {
              EDIT_BOOKING: { label: 'Booking Edit', color: '#1976d2', bg: '#e3f2fd', icon: '📝' },
              PAYMENT: { label: 'Payment', color: '#388e3c', bg: '#e8f5e9', icon: '💳' },
            }
            const config = typeConfig[type] || { label: type, color: '#616161', bg: '#f5f5f5', icon: '📢' }

            return (
              <span
                style={{
                  padding: '6px 12px',
                  borderRadius: '20px',
                  fontSize: '11px',
                  fontWeight: '600',
                  backgroundColor: config.bg,
                  color: config.color,
                  border: `1px solid ${config.color}33`,
                  display: 'inline-block',
                }}
              >
                {config.icon} {config.label}
              </span>
            )
          },
        },
      },
      {
        name: 'title_en',
        label: 'Title',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (title, tableMeta) => {
            const isRead = tableMeta.rowData[4]
            return (
              <div
                style={{
                  fontWeight: isRead ? '500' : '700',
                  color: isRead ? '#424242' : '#1976d2',
                  fontSize: '14px',
                }}
              >
                {title}
              </div>
            )
          },
        },
      },
      {
        name: 'message_en',
        label: 'Message',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (message, tableMeta) => {
            const isRead = tableMeta.rowData[4]
            return (
              <div
                style={{
                  maxWidth: '350px',
                  wordWrap: 'break-word',
                  color: isRead ? '#666' : '#424242',
                  fontSize: '13px',
                  lineHeight: '1.5',
                }}
              >
                {message}
              </div>
            )
          },
        },
      },
      {
        name: 'created_at',
        label: 'Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (created_at) => {
            return (
              <div>
                <div style={{ fontSize: '13px', color: '#424242', fontWeight: '500' }}>
                  <Moment format="MMM DD, YYYY">{created_at}</Moment>
                </div>
                <div style={{ fontSize: '11px', color: '#757575' }}>
                  <Moment format="hh:mm A">{created_at}</Moment>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_read',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_read) => {
            return (
              <div>
                {is_read ? (
                  <span
                    style={{
                      padding: '6px 12px',
                      borderRadius: '20px',
                      fontSize: '11px',
                      fontWeight: '600',
                      backgroundColor: '#e8f5e9',
                      color: '#2e7d32',
                      border: '1px solid #c8e6c9',
                      display: 'inline-block',
                    }}
                  >
                    ✓ Read
                  </span>
                ) : (
                  <span
                    style={{
                      padding: '6px 12px',
                      borderRadius: '20px',
                      fontSize: '11px',
                      fontWeight: '600',
                      backgroundColor: '#fff3e0',
                      color: '#e65100',
                      border: '1px solid #ffe0b2',
                      display: 'inline-block',
                    }}
                  >
                    ● Unread
                  </span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'reference_id',
        label: 'Reference ID',
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id, tableMeta) => {
            const isRead = tableMeta.rowData[4]
            return (
              <div style={{ display: 'flex', gap: '8px' }}>
                {!isRead && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation()
                      this.markAsRead(id)
                    }}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: '1px solid #4caf50',
                      backgroundColor: '#fff',
                      color: '#4caf50',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#4caf50'
                      e.target.style.color = '#fff'
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#fff'
                      e.target.style.color = '#4caf50'
                    }}
                    title="Mark as Read"
                  >
                    <i className="icofont icofont-ui-check"></i>
                  </button>
                )}
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    this.deleteNotification(id)
                  }}
                  style={{
                    padding: '6px 12px',
                    borderRadius: '6px',
                    border: '1px solid #f44336',
                    backgroundColor: '#fff',
                    color: '#f44336',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f44336'
                    e.target.style.color = '#fff'
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#fff'
                    e.target.style.color = '#f44336'
                  }}
                  title="Delete"
                >
                  <i className="icofont icofont-delete-alt"></i>
                </button>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            open: true,
          },
          () => {
            this.loadData()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
            open: true,
          },
          () => {
            this.loadData()
          }
        )
      },
      selectableRows: 'none',
      onRowClick: (rowData, rowMeta) => {
        const notification = this.state.notifications[rowMeta.dataIndex]
        if (notification) {
          this.handleNotificationClick(notification)
        }
      },
      setRowProps: () => ({
        style: { cursor: 'pointer' },
      }),
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'No notifications found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Notifications</h4>
                    </div>
                  </div>
                  <Button
                    onClick={this.markAllAsRead}
                    variant="contained"
                    color="primary"
                    size="sm"
                    startIcon={<i className="icofont icofont-ui-check"></i>}
                    style={{ marginLeft: '10px' }}
                  >
                    Mark All as Read
                  </Button>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Notifications</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title="Notification List"
                        className="table-responsive"
                        data={this.state.notifications}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NotificationList
